import React from 'react';
import { useApps } from '@/contexts/AppsContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Eye, Key, Brain } from 'lucide-react';

export default function AdminTenantsPage() {
  const { apps, selectApp } = useApps();
  const navigate = useNavigate();

  const handleInspect = (app, destination) => {
    selectApp(app);
    navigate(destination);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Apps</h1>
        <p className="text-muted-foreground">
          {apps.length} apps registered on the platform.
        </p>
      </div>

      <div className="space-y-3">
        {apps.map((app) => (
          <Card key={app.appId}>
            <CardContent className="flex items-center justify-between py-4 px-6">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-semibold">{app.name}</p>
                  <Badge
                    variant="outline"
                    className={cn(
                      'text-[10px]',
                      app.status === 'active'
                        ? 'border-emerald-500/50 text-emerald-500'
                        : 'border-muted-foreground/50 text-muted-foreground',
                    )}
                  >
                    {app.status}
                  </Badge>
                  <Badge variant="outline" className="text-[10px]">
                    {app.planTier || 'free'}
                  </Badge>
                </div>
                <p className="text-xs text-muted-foreground mt-0.5">
                  Owner: {app.adminEmail || 'No owner'} &middot; ID: {app.appId?.slice(0, 8)}...
                </p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <Button
                  variant="outline"
                  size="sm"
                  className="h-8 text-xs"
                  onClick={() => handleInspect(app, '/mind')}
                >
                  <Brain className="h-3.5 w-3.5 mr-1" />
                  Mind
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  className="h-8 text-xs"
                  onClick={() => handleInspect(app, '/keys')}
                >
                  <Key className="h-3.5 w-3.5 mr-1" />
                  Keys
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}

function cn(...args) {
  return args.filter(Boolean).join(' ');
}
